import { useDispatch } from 'react-redux';
import type { AppDispatch } from '../redux/store/store';
import { selectModule } from '../redux/slice/layoutSlice';
import { DEFAULT_MODULE_ID } from '../config/module-config';
import { PLATFORM } from '../config/platform';

// Brand mark — clicking returns to the Home module (mirrors webapp2's Logo).
export const Logo = () => {
  const dispatch = useDispatch<AppDispatch>();
  return (
    <button
      type="button"
      className="brand"
      onClick={() => dispatch(selectModule(DEFAULT_MODULE_ID))}
    >
      <img className="brand__logo" src={PLATFORM.logoSrc} alt="" aria-hidden="true" />
      <span className="brand__name">{PLATFORM.platform_name}</span>
    </button>
  );
};
